<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv">Helion &amp; Company Limited</a></p><a id="page_iv">
<p class="copyright0">26 Willow Road</p>
<p class="copyright0">Solihull</p>
<p class="copyright0">West Midlands</p>
<p class="copyright0">B91 1UE</p>
<p class="copyright0">England</p>
<p class="copyright0">Tel. 0121 705 3393</p>
<p class="copyright0">Fax 0121 711 4075</p>
</a><p class="copyright0"><a id="page_iv">Email: <span class="weblink"></span></a><a href="mailto:info@helion.co.uk"><span class="underline">info@helion.co.uk</span></a></p>
<p class="copyright0">Website: <span class="weblink"><a href="http://www.helion.co.uk" target="_blank"><span class="underline">www.helion.co.uk</span></a></span></p>
<p class="copyright0">Twitter: <span class="weblink"><a href="mailto:@helionbooks"><span class="underline">@helionbooks</span></a></span></p>
<p class="copyright0">Visit our blog at <span class="weblink"><a href="http://blog.helion.co.uk/" target="_blank"><span class="underline">blog.helion.co.uk/</span></a></span></p>
<p class="copyright1">Published by Helion &amp; Company 2017</p>
<p class="copyright0">Cover designed by Paul Hewitt, Battlefield Design (<span class="weblink"><a href="http://www.battlefield-design.co.uk" target="_blank"><span class="underline">www.battlefield-design.co.uk</span></a></span>)</p>
<p class="copyright1">Text © Lindsay O’Brien 2017</p>
<p class="copyright0">Photographs © Lindsay O’Brien unless otherwise credited</p>
<p class="copyright0">Map © Lindsay O’Brien</p>
<p class="copyright1">Every reasonable effort has been made to trace copyright holders and to obtain their permission for the use of copyright material. The author and publisher apologize for any errors or omissions in this work, and would be grateful if notified of any corrections that should be incorporated in future reprints or editions of this book.</p>
<p class="copyright1">ISBN 978-1-911512-02-8</p>
<p class="copyright2">eISBN 978-1-912866-92-2</p>
<p class="copyright1">British Library Cataloguing-in-Publication Data.</p>
<p class="copyright0">A catalogue record for this book is available from the British Library.</p>
<p class="copyright1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form, or by any means, electronic, mechanical, photocopying, recording or otherwise, without the express written consent of Helion &amp; Company Limited.</p>
<p class="copyright1">For details of other military history titles published by Helion &amp; Company</p>
<p class="copyright0">Limited, contact the above address, or visit our website: <span class="weblink"><a href="http://www.helion.co.uk" target="_blank"><span class="underline">http://www.helion.co.uk</span></a></span></p>
<p class="copyright1">We always welcome receiving book proposals from prospective authors.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?d1653278